<template>
  <el-date-picker class="h-40" v-model="childValue" type="daterange" :placeholder="placeholder" @input="change"></el-date-picker>
</template>

<script>
  export default {
    props: {
      value: '',
      placeholder: ''
    },
    data() {
      return {
        childValue: []
      }
    },
    created() {
      if (this.value && this.value.length) {
        let startDate = new Date(this.value[0] * 1000)
        let endDate = new Date(this.value[1] * 1000)
        if (this.isTypeDate(startDate) && this.isTypeDate(endDate)) {
          this.childValue = [startDate, endDate]
        }
      }
    },
    methods: {
      isTypeDate (value) {
        return typeof value == 'object' && value.getDate
      },
      change() {
        let startDate = ''
        let endDate = ''
        if (_g.isRealEmpty(this.childValue)) {
          this.childValue = []
        }
        if (this.childValue[0]) {
          startDate = moment(this.childValue[0]).unix()
        } else {
          startDate = ''
        }
        if (this.childValue[1]) {
          endDate = moment(this.childValue[1]).unix() + 86399
        } else {
          endDate = ''
        }
        let dateArr = [startDate, endDate]
        this.$emit('input', dateArr)
      }
    },
    watch: {
      'value'() {
        this.childValue = []
        if (this.value && this.value.length) {
          if (this.value[0] != '' && this.value[1] != '') {
            let startDate = new Date(this.value[0] * 1000)
            let endDate = new Date(this.value[1] * 1000)
            if (this.isTypeDate(startDate) && this.isTypeDate(endDate)) {
              this.childValue = [startDate, endDate]
            }
          }
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// daterangeFilter.vue?63a53ff6